import { CSSObject } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { bubble } from "../../shared/styles/useDatePickerStyles";

export const weekdayHeader: CSSObject = {
  display: "grid",
  gridTemplateColumns: "repeat(7, 44px)",
  gridAutoRows: "32px",
  paddingTop: "16px"
};

export const weekdayLabel: CSSObject = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: colors.gray500,
  paddingBottom: "8px"
};

export const dayGrid: CSSObject = {
  display: "grid",
  gridTemplateColumns: "repeat(7, 44px)",
  gridAutoRows: "32px",
  gridAutoColumns: "32px",
  rowGap: "8px",
  height: "232px",
  overflowY: "auto"
};

export const monthBubble = ({
  isSelected,
  isInRange,
  isToday,
  isDisabled
}: {
  isSelected: boolean;
  isInRange: boolean;
  isToday: boolean;
  isDisabled: boolean;
}): CSSObject => ({
  ...bubble({ isSelected, isInRange, isToday, isDisabled })
});
